module.exports = __webpack_public_path__ + "img/Icon material-history.b2f40e2d.png";